// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.main-row {
  height: 100%;
}

.main-col {
  height: 100%;
}

ion-card {
  height: 100%;
  margin: 0;
  border-radius: 16px;
  box-shadow: none;
  word-break: break-word;
  --color: var(--color-black);
  background: transparent;
  padding: 15px 5px;
  text-transform: uppercase;
  overflow: auto;
}
ion-card ion-card-content {
  border-top: 1px solid var(--color-black);
  padding: 10px 0px;
}
ion-card ion-card-content:first-of-type {
  border: none;
}

.border-bottom {
  border-bottom: 1px solid var(--color-black) !important;
}

.border-top {
  border-top: 1px solid var(--color-black) !important;
}

ion-col {
  color: var(--color-black);
  font-family: AppFont, sans-serif;
  text-align: right;
  font-size: 12px;
  text-transform: uppercase;
}
ion-col.header {
  text-align: center;
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  text-transform: uppercase;
}
ion-col div {
  text-align: left;
  color: #C1C1C1;
  text-transform: uppercase;
}
ion-col h3 {
  text-transform: uppercase;
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--color-black);
  text-align: left;
  text-transform: uppercase;
}
ion-col h3.right-col {
  text-align: right;
}

.your-order-title {
  text-transform: uppercase;
  color: var(--color-black);
  font-family: AppFontBold, sans-serif;
}

.header {
  font-size: 20px;
  font-family: AppFontExtraBold, sans-serif;
}

ion-chip {
  background: #E2DCD5;
  color: var(--color-black);
  height: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
  font-size: 11px;
}

.reorder-section {
  display: flex;
  justify-content: flex-end;
}

.reorder {
  color: var(--color-black);
  color: white !important;
  padding: 5px 10px;
  font-family: AppFontBold, sans-serif;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 16px;
  cursor: pointer;
  z-index: 99;
}

.delivery-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.delivery-info .btn {
  color: var(--color-black);
  padding: 8px 15px;
  border-radius: 16px;
  color: white;
  font-family: AppFontBold, sans-serif;
}

.reorder-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: -moz-fit-content;
  width: fit-content;
}
.reorder-section .reorder {
  background: var(--ion-color-primary);
  border-radius: 26px;
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.reorder-section .reorder:hover {
  background: var(--primary-btn);
}

.disabled {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-order/my-order.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAGA;EACE,YAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AAAF;AAIE;EACE,wCAAA;EACA,iBAAA;AAFJ;AAII;EACE,YAAA;AAFN;;AAMA;EACE,sDAAA;AAHF;;AAKA;EACE,mDAAA;AAFF;;AAIA;EACE,yBAAA;EACA,gCAAA;EACA,iBAAA;EACF,eAAA;EACE,yBAAA;AADF;AAEE;EACE,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;AADJ;AAIE;EACE,yBAAA;EAEA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AAHJ;AAKI;EACE,iBAAA;AAHN;;AAQA;EACE,yBAAA;EACA,yBAAA;EACA,oCAAA;AALF;;AAOA;EACE,eAAA;EACA,yCAAA;AAJF;;AAMA;EACE,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAHF;;AAKA;EACE,aAAA;EACA,yBAAA;AAFF;;AAIA;EACE,yBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oCAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AADF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAAF;AACE;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,oCAAA;AACJ;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EAAA,kBAAA;AACF;AAAE;EACE,oCAAA;EACA,mBAAA;EAEA,kCAAA;EAAA,6BAAA;AACJ;AAAI;EACE,8BAAA;AAEN;;AAEA;EACE,YAAA;AACF","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.main-row {\n  height: 100%;\n}\n\n.main-col {\n  height: 100%;\n\n}\n\nion-card {\n  height: 100%;\n  margin: 0;\n  border-radius: 16px;\n  box-shadow: none;\n  word-break: break-word;\n  --color: var(--color-black);\n  background: transparent;\n  padding: 15px 5px;\n  text-transform: uppercase;\n  overflow: auto;\n  // --preorder-type-chip-border-color:  #F2F2F2;;\n  // --preorder-type-chip-background:  #F2F2F2;;\n  // --preorder-type-chip-color: var(--ion-color-primary);\n  ion-card-content {\n    border-top: 1px solid var(--color-black);\n    padding: 10px 0px;\n\n    &:first-of-type {\n      border: none;\n    }\n  }\n}\n.border-bottom {\n  border-bottom: 1px solid var(--color-black) !important;\n}\n.border-top {\n  border-top: 1px solid var(--color-black) !important;\n}\nion-col {\n  color: var(--color-black);\n  font-family: AppFont, sans-serif;\n  text-align: right;\nfont-size: 12px;\n  text-transform: uppercase;\n  &.header {\n    text-align: center;\n    font-family: AppFontBold, sans-serif;\n    font-size: 16px;\n    color: var(--color-black);\n    text-transform: uppercase;\n\n  }\n  div {\n    text-align: left;\n    color:  #C1C1C1;\n    text-transform: uppercase;\n\n  }\n  h3 {\n    text-transform: uppercase;\n\n    font-family: AppFontBold, sans-serif;\n    font-size: 14px;\n    color: var(--color-black);\n    text-align: left;\n    text-transform: uppercase;\n\n    &.right-col {\n      text-align: right;\n    }\n  }\n}\n\n.your-order-title {\n  text-transform: uppercase;\n  color: var(--color-black);\n  font-family: AppFontBold, sans-serif;\n}\n.header {\n  font-size: 20px;\n  font-family: AppFontExtraBold, sans-serif;\n}\nion-chip{\n  background:  #E2DCD5;\n  color: var(--color-black);\n  height: 20px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  margin: 0px;\n  font-size: 11px;\n}\n.reorder-section {\n  display: flex;\n  justify-content: flex-end;\n}\n.reorder {\n  color: var(--color-black);\n  color: white !important;\n  padding: 5px 10px;\n  font-family: AppFontBold, sans-serif;\n  width: fit-content;\n  border-radius: 16px;\n  cursor: pointer;\n  z-index: 99;\n}\n.delivery-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  .btn {\n    color: var(--color-black);\n    padding: 8px 15px;\n    border-radius: 16px;\n    color: white;\n    font-family: AppFontBold, sans-serif;\n  }\n}\n.reorder-section {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: fit-content;\n  .reorder {\n    background: var(--ion-color-primary);\n    border-radius: 26px;\n    // border: 1px solid black;\n    width: fit-content !important;\n    &:hover {\n      background: var(--primary-btn);\n    }\n  }\n}\n.disabled {\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
